// extracted by mini-css-extract-plugin
export default {"wrap":"ContextMenu_wrap__qDYAs","buttom":"ContextMenu_buttom__5QThu"};